import React from 'react'

function Allnumbers() {
  return (
    <div>Allnumbers</div>
  )
}

export default Allnumbers